export enum PostSaleTypeEnum {
  PrintCreditCardReceipt = 'PrintCreditCardReceipt',
  WaitingForMoney = 'WaitingForMoney',
  SaveOrder = 'SaveOrder',
  CheckExitRole = 'CheckExitRole',
  PrintTickets = 'PrintTickets',
  PrintReceipt = 'PrintReceipt',
  OpenGate = 'OpenGate',
}
